module.exports = __webpack_public_path__ + "img/asteroid3.a8e2e2ee.jpg";